import { render } from "./ExcludedStudentsDialog.vue?vue&type=template&id=03f5caf8&scoped=true"
import script from "./ExcludedStudentsDialog.vue?vue&type=script&lang=js"
export * from "./ExcludedStudentsDialog.vue?vue&type=script&lang=js"

import "./ExcludedStudentsDialog.vue?vue&type=style&index=0&id=03f5caf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f5caf8"]])

export default __exports__